import { DRAWING_PATH_DEFAULTS } from './drawingDefaults';

global.drawing = {
    overlayOpacity: 0.6,
    strokeWidth: 0,
    ...DRAWING_PATH_DEFAULTS,
};
